import { AlarmUiState } from '@/store/modules/alarmUi/types'

export const state: AlarmUiState = {
  dialogOpened: false,
}
